import * as firebaseModule from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";
import "firebase/database";

// :: Environment Variables
const {
  VUE_APP_FIREBASE_API_KEY,
  VUE_APP_FIREBASE_AUTH_DOMAIN,
  VUE_APP_FIREBASE_DB_URL,
  VUE_APP_FIREBASE_PROJECT_ID,
  VUE_APP_FIREBASE_STORAGE_BUCKET,
  VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  VUE_APP_FIREBASE_APP_ID
} = process.env;

// :: Firebase configurations
// :: Client side ENV variables https://cli.vuejs.org/guide/mode-and-env.html#using-env-variables-in-client-side-code
const config = {
  apiKey: VUE_APP_FIREBASE_API_KEY,
  authDomain: VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: VUE_APP_FIREBASE_DB_URL,
  projectId: VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: VUE_APP_FIREBASE_APP_ID
};
// :: Initialize firebase app config
firebaseModule.initializeApp(config);

// :: Variable to initialize Firebase
export const firebase = firebaseModule;

// :: Firebase Storage reference
export const storageRef = firebaseModule.storage().ref();

// :: Firestore references
// :: Creates reference
export const firestoreDb = firebaseModule.firestore();

// :: cacheSizeBytes
// :: type of data : number
// :: this parameter receives the size in bytes
// :: this setup refers a 200MB of storage in cache
firebaseModule.firestore().settings({
  cacheSizeBytes: 209715200
});
// :: Enables the offline data persistance to save data in cache
firebaseModule.firestore().enablePersistence({
  synchronizeTabs: true
});

// :: Firestore reference for field usage
export const firestoreField = firebaseModule.firestore.FieldValue;
// :: Returns a reference for a collection
export const firestore = ref => firestoreDb.collection(ref);

export const database = ref => firebase.database().ref(ref);
export const timestampDatabase = firebase.database.ServerValue.TIMESTAMP;

// :: Firebase Auth references
// :: Creates reference
export const auth = firebaseModule.auth();
export const firebaseAuth = firebaseModule.auth;

// :: Firebase functions references
export const functions = firebaseModule.functions();
